module.exports = __webpack_public_path__ + "img/image_3_1.9380ada4.jpg";